import { useMutation } from '@tanstack/react-query'
import {
  postNotificationDestinations,
  PostNotificationDestinationsRequest,
} from 'services/WebHooksService'
import { BaseErrorResponse } from 'types/beneficiaries'
import { logSentryError } from 'utils/sentry'

export const useCreateNotificationDestinationsMutation = () => {
  return useMutation({
    mutationFn: (data: PostNotificationDestinationsRequest) => postNotificationDestinations(data),
    onError(error: BaseErrorResponse, data) {
      logSentryError('Error from useCreateWebhookDestinationsMutation', error, data)
    },
  })
}
